import Crum from '@/components/Crum';
import GoToIpForThePage from '@/components/GoToIpForThePage';
import PageLayout from '@/components/PageLayout';
import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import Empty from '@/components/Search/Empty';
import SEOlinksA from '@/components/SEOlinksA';
import SupportBannerPc from '@/components/SupportCommon/SupportBanner';
import SupportContactUs from '@/components/SupportCommon/SupportContactUs';
import SupportLeftMenu from '@/components/SupportCommon/SupportLeftMenu';
import SupportTitle from '@/components/SupportCommon/SupportTitle';
import CustomSpin from '@/components/UI/CustomSpin';
import Image from '@/components/UI/Image';
import Pagination from '@/components/UI/Pagination';
import Search from '@/components/UI/Search';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import SupportMenu from '@/componentsH5/SupportCommon/SupportMenu';
import seoconfig from '@/seoconfig/support/videos';
import { getDownloadCatagoryTree, getDownloadInfo } from '@/service';
import { isReadyLang, redirectTo404 } from '@/utils';
import generatorPlayUrl from '@/utils/generatorPlayUrl';
import { useGlobal } from '@/utils/useGlobal';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
let paramsTemp = {}; //分页查询使用
export default function SupportVideo({ categoryTree, lang, SEO }: any) {
    const { isMobile, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const SupportBanner = isMobile ? SupportBannerH5 : SupportBannerPc;

    const [isFirstIn, setIsFitstIn] = useState(true); // 是否首次进入页面（未发送请求）
    const [videoList, setVideoList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchContent, setSearchContent] = useState(''); // 手机端搜索框内容

    const [currentVideo, setCurrentVideo] = useState({
        isShow: false,
        videoUrl: '',
    });
    const [pageInfo, setPageInfo] = useState({
        page: 1,
        size: 12,
        total: 0,
    });

    const breadcrumbData = [{ name: t('crums.crum_home'), link: '/' }, { name: t('crums.crum_support'), link: '/support' }, { name: t('crums.crum_videos') }];

    /**
     * 获取下载列表
     * @params params 请求参数
     */
    const getVideoList = async (params: any) => {
        setLoading(true);
        paramsTemp = params; // 缓存搜索条件
        const { page } = params;
        const res = await getDownloadInfo({
            ...params,
            size: pageInfo.size,
            classify: 'VIDEO_COURSE',
        });
        setLoading(false);
        setIsFitstIn(false);
        if (res?.code === '0') {
            setVideoList(res.data?.content || []);
            setPageInfo({ ...pageInfo, total: res.data?.total || 0, page: page || 1 });
        }
    };

    /**
     * 侧边栏搜索
     * @param title 搜索关键字
     */
    const onSearch = (title: string) => getVideoList({ title }).catch();

    /**
     * 选择侧边栏回调
     * @param catagoryIdsStr 分类id
     */
    const onSelect = (ids: string, type: string) => {
        if (type === 'PRODUCT_CATAGORY') {
            getVideoList({ productCatagoryIds: ids }).catch();
        }
        if (type === 'SPU') {
            getVideoList({ spuIds: ids }).catch();
        }
        if (type === 'SKU') {
            getVideoList({ skuIds: ids }).catch();
        }
        if (type === 'SN') {
            getVideoList({ snInSkuIds: ids }).catch();
        }
    };

    /**
     * 分页查询
     * @param page 当前页码
     */
    const handlePageChange = (page: number) => {
        getVideoList({
            ...paramsTemp,
            page,
        }).catch();
    };

    /**
     * 点击播放视频
     * @param e
     */
    const handlePlayVideo = (e: any) => {
        const target = e.target?.closest('.mask');
        if (!target?.classList.contains('play')) return;
        const { url, isYoutube } = target.dataset;
        if (isYoutube === 'true') {
            setCurrentVideo({ videoUrl: url, isShow: true });
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.click();
        }
    };

    /**
     * 关闭播放视频
     */
    const closeVideo = () => setCurrentVideo({ videoUrl: '', isShow: false });

    const init = () => {
        if (isMobile) {
            if (!categoryTree[0]?.subs?.length) {
                getVideoList({
                    productCatagoryIds: categoryTree[0]?.downloadCatagoryId,
                }).catch(() => {
                    setIsFitstIn(false);
                });
            }
            if (categoryTree[0]?.subs?.length && !categoryTree[0]?.subs[0]?.subs?.length) {
                if (categoryTree[0].subs[0]?.downloadCatagoryType === 'PRODUCT_CATAGORY') {
                    getVideoList({
                        productCatagoryIds: categoryTree[0]?.subs[0]?.downloadCatagoryId,
                    }).catch(() => {
                        setIsFitstIn(false);
                    });
                }
                if (categoryTree[0]?.subs[0]?.downloadCatagoryType === 'SPU') {
                    getVideoList({
                        spuIds: categoryTree[0]?.subs[0]?.downloadCatagoryId,
                    }).catch(() => {
                        setIsFitstIn(false);
                    });
                }
            }
            if (categoryTree[0]?.subs?.length && categoryTree[0]?.subs[0]?.subs?.length) {
                getVideoList({
                    spuIds: categoryTree[0]?.subs[0]?.subs[0]?.downloadCatagoryId,
                }).catch(() => {
                    setIsFitstIn(false);
                });
            }
        } else {
            getVideoList({}).catch(() => {
                setIsFitstIn(false);
            });
        }
    };

    useEffect(() => {
        init();
        return () => {
            setVideoList([]);
        };
    }, [categoryTree, isMobile]);

    const handleEnter = (e: any) => {
        const keyword = e.target.value;
        if (e.keyCode !== 13 || !keyword) return;
        setSearchContent(keyword); // 防止闪动
        onSearch(String(keyword));
    };

    return (
        <PageLayout style={{ backgroundColor: '#fff' }}>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <div className={css.videoContainer}>
                <SupportBanner title={t('navigation.support.site_nav_support_welcome')} subTitle={t('navigation.support.site_nav_support_what_can')} />
                <Crum data={breadcrumbData} />
                <div className="wrapper">
                    <SupportTitle title={t('navigation.support.site_nav_support_videos')} />
                    {isMobile && <SupportMenu categoryTree={categoryTree} onSelect={onSelect} />}
                    <div className="content">
                        {!isMobile && (
                            <SupportLeftMenu
                                categoryTree={categoryTree}
                                fieldNames={{
                                    title: 'name',
                                    value: 'downloadCatagoryId',
                                    children: 'subs',
                                    type: 'downloadCatagoryType',
                                }}
                                onSearch={onSearch}
                                onSelect={onSelect}
                            />
                        )}
                        {isMobile && (
                            <div className="searchBox">
                                <Search
                                    allowClear={true}
                                    placeholder={t('support.faq.site_support_faq_search')}
                                    value={searchContent}
                                    autoFilter={true}
                                    fieldNames={{ label: 'name', value: 'name' }}
                                    onInputKeyDown={handleEnter}
                                />
                            </div>
                        )}
                        <div className={` ${isMobile ? 'videoListH5' : ''} videoList`}>
                            <CustomSpin loading={loading} customClass="video-spin" />
                            <ul className="videoUL" onClick={handlePlayVideo} style={{ opacity: loading ? 0 : 1 }}>
                                {videoList &&
                                    videoList?.length > 0 &&
                                    videoList?.map((videoItem: any) => (
                                        <li className="videoItem" key={videoItem.downloadInfoId}>
                                            <div className="videos">
                                                <div
                                                    data-url={generatorPlayUrl(videoItem.fileUrl).url}
                                                    data-is-youtube={generatorPlayUrl(videoItem.fileUrl).isYouTubeVideo}
                                                    className={`play mask ${videoItem?.poster ? 'posterMask' : ''}`}
                                                >
                                                    <Image
                                                        src={videoItem?.poster || generatorPlayUrl(videoItem.fileUrl)?.imageUrl || '/img/search/error.png'}
                                                        layout="fill"
                                                        alt={videoItem.title}
                                                    />
                                                    <div className="play">
                                                        <Image src="/icons/play-support.svg" layout="fill" alt={t('support.download.play_icon')} />
                                                    </div>
                                                </div>
                                            </div>
                                            <p data-url={videoItem.fileUrl} className="video_title">
                                                {videoItem.title}
                                            </p>
                                        </li>
                                    ))}
                            </ul>
                            <div className="page-content">
                                <Pagination
                                    className="page"
                                    current={pageInfo.page}
                                    pageSize={pageInfo.size}
                                    total={pageInfo.total}
                                    hideOnSinglePage={true}
                                    showSizeChanger={false}
                                    onChange={handlePageChange}
                                />
                            </div>
                            {/* 无结果 */}
                            {(!Array.isArray(videoList) || videoList?.length === 0) && !isFirstIn && <Empty isMobile={isMobile} />}
                        </div>
                    </div>
                    <SupportContactUs isShow={true} />
                </div>

                <YouTubeVideoPlayer floatVideo={currentVideo.isShow} setFloatVideo={closeVideo} videoSrc={`${currentVideo.videoUrl}?autoplay=1`} />
            </div>
            <GoToIpForThePage />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: any) {
    if (!isReadyLang(locale)) {
        return redirectTo404();
    }
    const type = 'VIDEO_COURSE';
    const res = await getDownloadCatagoryTree(locale, type);
    const categoryTree = res?.data;

    return {
        props: {
            categoryTree: categoryTree || [],
        },
    };
}
